/** Request ids from getRandomValues: randomUUID exists only in secure contexts (HTTPS). */
export function browserRequestId() {
  return Array.from(crypto.getRandomValues(new Uint32Array(4)), (value) =>
    value.toString(16).padStart(8, '0'),
  ).join('-')
}
